export default {
  data () {
    return {
      toggleStatus: {
        isShow: false
      }
    }
  },
  computed: {
    isSelected () {
      return this.toggleStatus.isShow ? 'is-selected' : ''
    }
  },
  methods: {
    toggle () {
      this.toggleStatus.isShow = !this.toggleStatus.isShow
    },
    toggleOn () {
      this.toggleStatus.isShow = true
    },
    toggleOff () {
      this.toggleStatus.isShow = false
    }
  }
}
